import { createContext, useContext } from 'react';

/**
 * Lets a page collapse the site header (logo, search, tabs) to give its content more height, and
 * exposes the element that scrolls the page so the page can decide when to do it. Provided by
 * Layout; outside it the setter is a no-op.
 */
export const SiteHeaderContext = createContext({
  scrollContainerRef: { current: null },
  setSiteHeaderHidden: () => {}
});

export const useSiteHeader = () => useContext(SiteHeaderContext);
